import { Reveal, Eyebrow } from "@/components/Reveal";
import { ExternalLink, FlaskConical } from "lucide-react";
import { imgSrc } from "@/lib/api";

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6"];

export default function Portfolio({ items }) {
  return (
    <section id="work" className="bg-[#070B16] py-24 lg:py-32" data-testid="portfolio-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal className="max-w-3xl">
          <Eyebrow>Our Work</Eyebrow>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            Concepts that show what we can build for you.
          </h2>
          <p className="mt-5 flex items-start gap-2.5 text-base text-slate-400 sm:text-lg">
            <FlaskConical size={19} className="mt-1 shrink-0 text-[#00F0FF]" />
            These are demo projects — design concepts created by our studio to showcase our style
            and capability. Client projects will appear here as they launch, with permission.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-5 md:grid-cols-12">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.1} className={SPANS[i % SPANS.length]}>
              <article
                data-testid={`portfolio-card-${p.id}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-[#0A0F1C]"
              >
                <div className="relative max-h-[80vh] overflow-hidden">
                  <img
                    src={imgSrc(p.image)}
                    alt={`${p.title} — ${p.category} demo project`}
                    className="h-72 w-full object-cover transition-transform duration-700 group-hover:scale-105 md:h-80"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050811] via-[#050811]/20 to-transparent" />
                  {p.isDemo && (
                    <span className="absolute left-4 top-4 rounded-full border border-[#00F0FF]/40 bg-black/60 px-3.5 py-1 text-xs font-bold uppercase tracking-widest text-[#00F0FF] backdrop-blur">
                      Demo Project
                    </span>
                  )}
                </div>
                <div className="relative -mt-10 p-7">
                  <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#00F0FF]">
                    {p.category}
                  </p>
                  <h3 className="mt-2 font-display text-2xl font-bold text-white">{p.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{p.description}</p>
                  {p.link ? (
                    <a
                      href={p.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`portfolio-link-${p.id}`}
                      className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-white transition-colors duration-200 hover:text-[#00F0FF]"
                    >
                      View live <ExternalLink size={14} />
                    </a>
                  ) : (
                    <p className="mt-4 text-xs text-slate-500">Live link available on request</p>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
